/**
 * Standalone entry point for web component that auto-registers with customElements.
 * This file is used when loading the component via CDN/script tag.
 */
import { PaymentElementWebComponent } from './PaymentElementWebComponent';

/** Default web component tag name for the Payment Element. */
export const DEFAULT_PAYMENT_ELEMENT_TAG = 'cloudbeds-payment-element';

// Auto-register the custom web component
if (typeof customElements !== 'undefined') {
  if (!customElements.get(DEFAULT_PAYMENT_ELEMENT_TAG)) {
    customElements.define(
      DEFAULT_PAYMENT_ELEMENT_TAG,
      PaymentElementWebComponent,
    );
  }
}

// Export for UMD builds
export { PaymentElementWebComponent };
export default PaymentElementWebComponent;
